// eslint-disable-next-line
export const convertNewLineToBreak = (text) => text.replace(/\n/g, ' <br>');
